import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { PageDetailComponent } from '@next/core-lib/components';
import { LocaleService } from '@next/core-lib/i18n';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { getSelectedCycle } from '../../store/selectors/cycle.selectors';
import { CycleNavigationComponent } from '../cycle-navigation/cycle-navigation.component';

@Component({
  selector: 'app-cycle-item',
  templateUrl: 'cycle-item.component.html',
  imports: [PageDetailComponent, CycleNavigationComponent, RouterOutlet, AsyncPipe],
})
export class CycleItemComponent {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly locale = inject(LocaleService);
  private router = inject(Router);

  pageTitle$: Observable<string> = this.store.pipe(
    select(getSelectedCycle),
    map((cycle) => {
      const title = this.locale.translate('cycle');
      const number =
        !!cycle && Object.prototype.hasOwnProperty.call(cycle, 'cycleNumber')
          ? String(cycle.cycleNumber)
          : '';
      const date =
        !!cycle && Object.prototype.hasOwnProperty.call(cycle, 'cycleDate') && !!cycle.cycleDate
          ? `(${new Date(cycle.cycleDate).toLocaleDateString()})`
          : '';

      return `${title} ${number} ${date}`;
    }),
  );

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  getState = (outlet: RouterOutlet) => outlet.isActivated && outlet.activatedRoute.routeConfig.data;

  back = () => this.router.navigate(['/cycle']);
}
